class NavDrawerComponent extends HTMLElement {
  connectedCallback() {
    this.container = this.querySelector('.nav-drawer__container');
    this.overlay = this.querySelector('.nav-drawer__overlay');
    this.trigger = this.querySelector('.nav-drawer__button-show');

    this.trigger?.addEventListener('click', () => this.open());

    this.querySelectorAll('.nav-drawer__close, .nav-drawer__overlay').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });

    // Toggle button fills the dead-space in the row — clicking it toggles the accordion
    this.querySelectorAll('.nav-drawer__toggle').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleSubmenu(btn.closest('.nav-drawer__item'));
      });
    });

    // All nav links close the drawer before navigating
    this.querySelectorAll('.nav-drawer__item-link, .nav-drawer__sublink').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const href = link.getAttribute('href');
        this.close();
        const onEnd = (ev) => {
          if (ev.propertyName !== 'transform') return;
          this.container.removeEventListener('transitionend', onEnd);
          window.location.href = href;
        };
        this.container.addEventListener('transitionend', onEnd);
      });
    });
  }

  open() {
    // Close filter drawer if open
    const filterContainer = document.querySelector('.facets__container.active');
    if (filterContainer) {
      filterContainer.classList.remove('active');
      document.querySelector('.facets__container__overlay.active')?.classList.remove('active');
    }

    this.container.classList.add('active');
    this.overlay.classList.add('active');
    this.trigger?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.container.classList.remove('active');
    this.overlay.classList.remove('active');
    this.trigger?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden');
  }

  toggleSubmenu(item) {
    const submenu = item?.querySelector('.nav-drawer__submenu');
    if (!submenu) return;

    const btn = item.querySelector('.nav-drawer__toggle');
    const isOpen = !submenu.hidden;
    submenu.hidden = isOpen;
    btn?.classList.toggle('nav-drawer__toggle--open', !isOpen);
    btn?.setAttribute('aria-expanded', String(!isOpen));
  }
}

customElements.define('nav-drawer-component', NavDrawerComponent);

function initStickyBar() {
  const buttonsRow = document.querySelector('.facets__mobile-buttons-row');
  if (!buttonsRow) return;

  const filterBtn = document.querySelector('.facets__button-show');
  const navBtn = document.querySelector('.nav-drawer__button-show');
  if (!filterBtn && !navBtn) return;

  const stickyBar = document.createElement('div');
  stickyBar.className = 'facets__sticky-bar';
  stickyBar.setAttribute('aria-hidden', 'true');

  if (filterBtn) {
    const proxy = document.createElement('button');
    proxy.type = 'button';
    proxy.className = filterBtn.className;
    proxy.innerHTML = filterBtn.innerHTML;
    proxy.addEventListener('click', () => filterBtn.click());
    stickyBar.appendChild(proxy);
  }

  if (navBtn) {
    const proxy = document.createElement('button');
    proxy.type = 'button';
    proxy.className = navBtn.className;
    proxy.innerHTML = navBtn.innerHTML;
    proxy.addEventListener('click', () => navBtn.click());
    stickyBar.appendChild(proxy);
  }

  document.body.appendChild(stickyBar);

  let rowVisible = true;
  let footerVisible = false;

  function sync() {
    stickyBar.classList.toggle('facets__sticky-bar--visible', !rowVisible && !footerVisible);
  }

  new IntersectionObserver(([entry]) => {
    rowVisible = entry.isIntersecting;
    sync();
  }).observe(buttonsRow);

  const footer = document.querySelector('.footer');
  if (footer) {
    new IntersectionObserver(([entry]) => {
      footerVisible = entry.isIntersecting;
      sync();
    }).observe(footer);
  }
}

initStickyBar();
